import React from 'react';
import { useHistory, useParams } from 'react-router';
import { useMutation, useQuery, gql } from '@apollo/client';
import { PageContainer } from '@ant-design/pro-layout';
import { Descriptions, Card, message, List } from 'antd';
import ProjectHeader from '../../ProjectHeader';
import { DateDisplay } from 'components/layout';
import {
  ADD_SCHEDULED_REPORT_SUBMISSION,
  GET_REPORT_SUBMISSIONS,
} from '../../../../gql/reportSubmissions';
import ReportSubmissionScheduleForm from '../components/ReportSubmissionScheduleForm';
// import ProposalRevisionSteps from '../components/ProposalRevisionSteps';

const GET_PROJECT_SCHEDULE = gql`
  query GET_PROJECT_SCHEDULE($ids: [ID!], $status: Status) {
    projects(ids: $ids, status: $status) {
      nodes {
        id
        profile {
          originalStartDate
          originalCompletionDate
          lastApprovedCompletionDate
        }
      }
    }
  }
`;

const AddReportSubmission = () => {
  const { projectId } = useParams();
  const history = useHistory();
  const [addReportSubmission] = useMutation(ADD_SCHEDULED_REPORT_SUBMISSION, {
    refetchQueries: [
      {
        query: GET_REPORT_SUBMISSIONS,
        variables: {
          projectIds: [projectId],
        },
      },
    ],
    onCompleted: () => {
      message.success(`Report Submission Schedule saved`);
      history.push(`/projects/${projectId}/report-submissions`);
    },
  });

  const { data, loading } = useQuery(GET_PROJECT_SCHEDULE, {
    variables: { ids: [projectId], status: 'ALL' },
  });
  const onFinish = async ({
    reportType,
    scheduledSubmissionDate,
    reportingPeriod,
  }) => {
    await addReportSubmission({
      variables: {
        input: {
          projectId,
          reportType,
          scheduledSubmissionDate,
          reportingPeriod,
        },
      },
    });
  };

  const profile = data?.projects?.nodes?.[0]?.profile;

  return (
    <ProjectHeader>
      <PageContainer
        header={{ title: 'New Report Submission Schedule' }}
        ghost
        style={{ marginBottom: '32px' }}
      >
        {/* <ProposalRevisionSteps current={0} /> */}
        <Card title="Schedule" style={{ marginTop: '24px' }} loading={loading}>
          <List>
            <List.Item>
              <Descriptions title="Original Project Schedule">
                <Descriptions.Item label="Start Date">
                  <DateDisplay date={profile && profile.originalStartDate} />
                </Descriptions.Item>
                <Descriptions.Item label="Completion Date">
                  <DateDisplay
                    date={profile && profile.originalCompletionDate}
                  />
                </Descriptions.Item>
                <Descriptions.Item label="Last Approved Completion Date">
                  <DateDisplay
                    date={profile && profile.lastApprovedCompletionDate}
                  />
                </Descriptions.Item>
              </Descriptions>
            </List.Item>
          </List>
        </Card>
        <ReportSubmissionScheduleForm onFinish={onFinish} />
      </PageContainer>
    </ProjectHeader>
  );
};

export default AddReportSubmission;
